import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { tokens } from "../theme";
import CloseIcon from '@mui/icons-material/Close'



const ConfirmDialog = (props) => {
    const { title, message, confirmBtnText, open, setOpen, onConfirm } = props;
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <Box position="absolute" top={0} right={0}>
                <IconButton onClick={() => setOpen(false)} >
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => setOpen(false)}
                    sx={
                        {
                            backgroundColor: colors.grey[700],
                            color: "#ffffff",
                            '&:hover': {
                                backgroundColor: colors.grey[500],
                                color: "#ffffff",
                            },
                        }
                    }
                    variant="contained">
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        setOpen(false);
                        onConfirm();
                    }}
                    sx={
                        {
                            backgroundColor: colors.redAccent[500],
                            color: "#ffffff",
                            '&:hover': {
                                backgroundColor: colors.redAccent[400],
                                color: "#ffffff",
                            },

                        }
                    }
                    variant="contained">
                    {confirmBtnText}
                </Button>
            </DialogActions>
        </Dialog >
    );
};

export default ConfirmDialog;